import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { QUESTION_SYNC, SURVEY_IDENTIFIER, SURVEY_LANGUAGE } from "../../../../ducks/survey";

import { filterSelected, TEMPLATE_LANGUAGES } from "../../../../ducks/surveySettings";

import QuestionLibrarySurveyEditor from "./QuestionLibrarySurveyEditor";
import {
  ACTION_FIELD,
  addQuestionToLibrary,
  addQuestionToMyLibrary,
  addQuestionToTemplate,
  changeProperty,
  getQuestionLibrary,
  QUESTION_ACTION_FIELD,
  QUESTION_ID,
  QUESTION_ID_VALID,
  QUESTION_LIBRARY,
  QUESTION_NAME,
  QUESTION_RESULT,
  QUESTION_TO_BE_ADDED,
  QUESTIONS_TO_ADD,
  RESULT,
  SHOW_MODAL_ADD_QUESTION_FROM_LIBRARY,
  SHOW_MODAL_QUESTION_LIBRARY_SETTINGS,
  submitAdding,
  SURVEY_LANGUAGE_FOR_QUESTION_LIBRARY
} from "../../../../ducks/questionLibrary";
import { ACTION_FIELDS, INDICATORS, loadAllData, QUESTIONS, RESULTS } from "../../../../ducks/indicatorManagament";
import { LANGUAGE } from "../../../../ducks/languageSelector";
import {
  INDICATOR_MANAGEMENT_STORE,
  LANGUAGE_SELECTOR,
  PAGES_KEY,
  QUESTION_LIBRARY_STORE,
  SURVEY,
  SURVEY_EDITOR
} from "../../../../common/constant";
import { changeQuestionField, removeQuestion } from "../../../../ducks/surveyEditorActions";

const flatArray = (array) => {
  return array.reduce((acc, val) => acc.concat(val), []);
};

const mapStateToProps = (state) => {
  let surveyContainedQuestionIds = undefined;
  if (state[SURVEY][SURVEY_IDENTIFIER]) {
    surveyContainedQuestionIds = flatArray(
      state[SURVEY_EDITOR][PAGES_KEY].filter((page) => page.questions).map((page) =>
        page.questions.map((q) => q.libraryQuestionId)
      )
    ).filter((libraryQuestionId) => !!libraryQuestionId); // make single array of an array of arrays
  }

  const questionLibrary = state[QUESTION_LIBRARY_STORE];
  return {
    surveyLanguage: state.surveySettings[SURVEY_LANGUAGE],
    surveyLanguageForQuestionLibrary: questionLibrary[SURVEY_LANGUAGE_FOR_QUESTION_LIBRARY],
    showModalQuestionLibrarySettings: questionLibrary[SHOW_MODAL_QUESTION_LIBRARY_SETTINGS],
    showModalAddQuestionFromLibrary: questionLibrary[SHOW_MODAL_ADD_QUESTION_FROM_LIBRARY],
    questionName: questionLibrary[QUESTION_NAME],
    questionId: questionLibrary[QUESTION_ID],
    questionIdValid: questionLibrary[QUESTION_ID_VALID],
    questionActionField: questionLibrary[QUESTION_ACTION_FIELD],
    questionResult: questionLibrary[QUESTION_RESULT],
    questionLibrary: questionLibrary[QUESTION_LIBRARY],
    templateLanguages: state.surveySettings[TEMPLATE_LANGUAGES],
    questionToBeAdded: questionLibrary[QUESTION_TO_BE_ADDED],
    questionsToAdd: questionLibrary[QUESTIONS_TO_ADD],
    selectedActionField: questionLibrary[ACTION_FIELD],
    selectedResult: questionLibrary[RESULT],
    selectedPage: state.surveyEditor.selectedPage,
    actionFields: state[INDICATOR_MANAGEMENT_STORE][ACTION_FIELDS],
    results: state[INDICATOR_MANAGEMENT_STORE][RESULTS],
    indicators: state[INDICATOR_MANAGEMENT_STORE][INDICATORS],
    questions: state[INDICATOR_MANAGEMENT_STORE][QUESTIONS],
    locale: state[LANGUAGE_SELECTOR][LANGUAGE],
    questionSync: state.survey[QUESTION_SYNC],

    selectedQuestionIds: surveyContainedQuestionIds
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      changeProperty,
      changeQuestionField,
      removeQuestion,
      filterSelected,
      addQuestionToLibrary,
      addQuestionToMyLibrary,
      getQuestionLibrary,
      addQuestionToTemplate,
      submitAdding,
      loadAllData
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(QuestionLibrarySurveyEditor);
